import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	previousButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nextButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	previousButton: {
		id: 'directory-base.content.paginator.previous-button',
		defaultMessage: 'Previous page',
		description: 'Previous page button of pagination in a directory level page',
	},
	nextButton: {
		id: 'directory-base.content.paginator.next-button',
		defaultMessage: 'Next page',
		description: 'Next page button of pagination in a directory level page',
	},
});
export default messages;
